module.exports = __webpack_public_path__ + "img/SolO.5cd16827.png";